import { PersonJobType } from '@api';
import {
  TouringCard,
  TouringCardHeader,
  TouringCardSection,
  TouringCardTitle,
  TouringDataTable,
  useManageTableContext,
} from '@common';
import { useTranslation } from 'react-i18next';
import { useColumns } from '../../common';

type UpcomingShowsPropsType = {
  upcomingShows: PersonJobType[];
  isPending: boolean;
};

export const UpcomingShows: React.FC<UpcomingShowsPropsType> = ({
  upcomingShows,
  isPending,
}) => {
  const { t } = useTranslation('personDetailsTourRep');
  const { columns } = useColumns();
  const { tableArguments: table } = useManageTableContext();

  return (
    <TouringCard data-testid="upcoming-shows-container">
      <TouringCardHeader>
        <TouringCardTitle>
          {t('TOUR_REP_SELF_PROMOTE.UPCOMING_SHOWS.TITLE')}
        </TouringCardTitle>
      </TouringCardHeader>
      <TouringCardSection>
        <TouringDataTable<PersonJobType>
          records={upcomingShows}
          columns={columns}
          idAccessor="showTypeMinified.showId"
          {...table.pagination}
          fetching={isPending}
          withColumnBorders={false}
          withTableBorder={false}
        />
      </TouringCardSection>
    </TouringCard>
  );
};
